import React, { useState } from "react";
import PlusIcon from "../icons/BusinessHub/PlusIcon";
import SubcategoryRow from "./SubcategoryRow";

function SubcategoryList({
  category,
  selectedSubCategoryId,
  loading,
  onAddSubcategory,
  onSelectSubcategory,
  onToggleVisibility,
  onEditSubcategory,
  onDeleteSubcategory,
  onReorderSubcategories,
  orderDirty,
  onUploadOrder,
}) {
  const subcategories = category?.subCategories || [];
  const [draggedSubcategoryId, setDraggedSubcategoryId] = useState("");
  const [dragOverSubcategoryId, setDragOverSubcategoryId] = useState("");

  const clearDragState = () => {
    setDraggedSubcategoryId("");
    setDragOverSubcategoryId("");
  };

  const getSubcategoryIndex = (subCategoryId) =>
    subcategories.findIndex(
      (subcategory) => subcategory.subCategoryId === subCategoryId,
    );

  const handleDragStart = (event, subCategoryId) => {
    setDraggedSubcategoryId(subCategoryId);
    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.setData("text/plain", subCategoryId);
  };

  const handleDragOver = (event, targetSubCategoryId) => {
    event.preventDefault();

    const sourceSubCategoryId =
      draggedSubcategoryId || event.dataTransfer.getData("text/plain");
    if (!sourceSubCategoryId || sourceSubCategoryId === targetSubCategoryId) {
      return;
    }

    const sourceIndex = getSubcategoryIndex(sourceSubCategoryId);
    const targetIndex = getSubcategoryIndex(targetSubCategoryId);
    if (sourceIndex === -1 || targetIndex === -1) return;

    setDragOverSubcategoryId(targetSubCategoryId);
    onReorderSubcategories(sourceIndex, targetIndex);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    clearDragState();
  };

  return (
    <div className="category-settings-panel">
      <div className="category-settings-panel-header">
        <div>
          <div className="category-settings-panel-title">Subcategories</div>
          <div className="category-settings-panel-meta">
            {category ? category.categoryName : "No category selected"}
          </div>
        </div>
        <div className="category-settings-panel-actions">
          <button
            className="category-settings-upload-order-btn"
            onClick={onUploadOrder}
            disabled={!category || !orderDirty}
          >
            Upload Order
          </button>
          <button
            className="category-settings-primary-btn"
            onClick={onAddSubcategory}
            disabled={!category}
          >
            <PlusIcon fill="#ffffff" />
            <span>Add Subcategory</span>
          </button>
        </div>
      </div>

      {!category ? (
        <div className="category-settings-empty-state category-settings-empty-state-large">
          Select a category to manage its subcategories.
        </div>
      ) : loading ? (
        <div className="category-settings-empty-state category-settings-empty-state-large">
          Loading subcategories...
        </div>
      ) : (
        <div className="category-settings-list">
          {subcategories.length ? (
            subcategories.map((subcategory) => (
              <SubcategoryRow
                key={subcategory.subCategoryId}
                subcategory={subcategory}
                isSelected={
                  subcategory.subCategoryId === selectedSubCategoryId
                }
                isDragging={
                  subcategory.subCategoryId === draggedSubcategoryId
                }
                isDragOver={
                  subcategory.subCategoryId === dragOverSubcategoryId
                }
                onSelect={() => onSelectSubcategory(subcategory.subCategoryId)}
                onDragStart={(event) =>
                  handleDragStart(event, subcategory.subCategoryId)
                }
                onDragOver={(event) =>
                  handleDragOver(event, subcategory.subCategoryId)
                }
                onDragEnter={() =>
                  setDragOverSubcategoryId(subcategory.subCategoryId)
                }
                onDrop={handleDrop}
                onDragEnd={clearDragState}
                onToggleVisibility={() =>
                  onToggleVisibility(subcategory.subCategoryId)
                }
                onEdit={() => onEditSubcategory(subcategory)}
                onDelete={() => onDeleteSubcategory(subcategory)}
              />
            ))
          ) : (
            <div className="category-settings-empty-state">
              This category has no subcategories yet.
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default SubcategoryList;
